<template>
  <div>
    <div class="action-buttons">
      <div class="left-buttons">
        <div class="form-group" style="flex: 1;">
          <label>{{ $t('gestiune.locatie') }}</label>
          <select class="form-control" v-model="selectedLocation" :disabled="loading">
            <option :value="null">Selectează</option>
            <optgroup
              v-for="group in groupedLocations"
              :key="group.vat"
              :label="`VAT: ${group.vat}`"
            >
              <option
                v-for="loc in group.locations"
                :key="loc.id"
                :value="loc"
              >
                {{ loc.name }}
              </option>
            </optgroup>
          </select>
        </div>
        <div class="search-button-reports">
          <button
              :title="$t('reports.search')"
              class="btn add mar-rt-10"
              @click="onSearchPurchases"
          >
              <i class="ti-search"></i>
              <span>{{ $t('general.search') }}</span>
          </button>
        </div>
       </div>
       <div class="right-buttons">
          <button class="btn add mar-rt-10"  @click.prevent="fetchInvoices()" :title="$t('general.fetchInvoice') + ' ' + $t('settingUsers.single')">
            {{$t('gestiune.fetchInvoice')}}
          </button>
        </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>

        <div class="data-table">
          <el-table :data="tableData" :empty-text="$t('gestiune.noData')">
            <el-table-column :label="$t('gestiune.nr')" prop="number" width="150">
              <template slot-scope="scope">
                {{ scope.row.number }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.furnizor')" prop="supplierName">
              <template slot-scope="scope">
                {{ scope.row.supplierName }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.valoareTaxable')" prop="taxableValue" align="left" header-align="left">
              <template slot-scope="scope">
                {{ scope.row.taxableValue }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.valoareTva')" prop="taxValue" align="left" header-align="left">
              <template slot-scope="scope">
                {{ scope.row.taxValue }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.valoareTotal')" prop="totalValue" align="left" header-align="left">
              <template slot-scope="scope">
                {{ scope.row.totalValue }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.valoarePayable')" prop="payableValue" align="left" header-align="left">
              <template slot-scope="scope">
                <strong>{{ scope.row.payableValue }}</strong>
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.dataEmitere')" prop="issueDate">
              <template slot-scope="scope">
                {{ scope.row.issueDate }}
              </template>
            </el-table-column>

            <el-table-column prop="id" :label="$t('marketingOffers.actions')" width="100">
              <template slot-scope="scope">
                <el-dropdown trigger="click" placement="bottom-end">
                  <span class="arrow-box">&#9662;</span>
                  <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item
                      @click.native="goToInvoiceSupplier(scope.row)"
                    >
                      {{$t('general.see')}}
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="viewPdf(scope.row)"
                    >
                      {{$t('gestiune.seePDF')}}
                    </el-dropdown-item>

                    <el-dropdown-item
                      @click.native="exportDocument(scope.row)"
                    >
                      {{$t('gestiune.exportDocument')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            layout="prev, pager, next"
            :total="totalItems"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handlePageChange"
            style="margin-top: 15px; text-align: right;"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'

export default {
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      totalItems: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      selectedLocation: null
    }
  },
  props: {
    groupedLocations: { type: Array, required: true }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')

    this.$bus.$on('refresh', this.refreshPurchases)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.refreshPurchases)
  },
  methods: {
    formatMoney (amount) {
      if (!amount || typeof amount !== 'object') return '0.00 RON'

      const value = Number(amount.value || 0)
      const currency = amount.currency || 'RON'

      return `${value.toFixed(2)} ${currency}`
    },
    goToInvoiceSupplier (row) {
      this.$router.push({ name: 'ManagementInvoiceSupplierView', params: { id: row.id } })
    },
    refreshPurchases () {
      this.fetchPurchases(this.selectedLocation, this.currentPage, this.pageSize)
    },
    onSearchPurchases () {
      if (!this.selectedLocation) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        })
        this.tableData = []
        this.totalItems = 0
        return
      }

      this.fetchPurchases(this.selectedLocation)
    },
    handlePageChange (page) {
      this.currentPage = page
      this.fetchPurchases(this.selectedLocation, this.currentPage, this.pageSize)
    },
    async fetchInvoices () {
      if (!this.companyID || !this.selectedLocation || !this.selectedLocation.inv_fiscal_code) {
        swal({
          type: 'warning',
          title: this.$t('general.required'),
          text: 'Selectați cel puțin o locație',
          confirmButtonText: 'OK'
        })

        return
      }

      const params = new URLSearchParams({
        externalCompanyId: this.companyID,
        zile: 30,
        cif: this.selectedLocation.inv_fiscal_code.replace(/^ro/i, ''),
        filtru: 'P'
      })

      const baseHost = process.env.API_BASE_URL_GESTIUNE.replace(/\/$/, '')
      const baseUrl = `${baseHost}:4443`
      const url = `${baseUrl}/efactura/inbox/import?${params.toString()}`

      try {
        this.loading = true

        const response = await fetch(url)
        const data = await response.json()

        if (!response.ok) {
          throw new Error(data.message || 'Import failed')
        }

        swal({
          icon: (data.imported && data.imported.length > 0) ? 'success' : 'info',
          title: this.$t('general.success'),
          html:
            '<div>' +
              '<p><b>Message:</b> ' + (data.message ? data.message : '-') + '</p>' +
              '<p><b>Imported:</b> ' + (data.imported ? data.imported.length : 0) + '</p>' +
              '<p><b>Skipped:</b> ' + (data.skipped ? data.skipped.length : 0) + '</p>' +
            '</div>',
          confirmButtonText: 'OK'
        })
      } catch (error) {
        console.error(error)

        swal({
          icon: 'error',
          title: this.$t('general.error'),
          text: error.message || 'Error importing invoices',
          confirmButtonText: 'OK'
        })
      } finally {
        this.loading = false
      }
    },
    async fetchPurchases (location = null, page = 1, pageSize = 20) {
      if (!this.companyID) {
        console.error('Missing company ID for fetching purchases.')
        return
      }

      if (!location || !location.inv_fiscal_code) return

      this.loading = true
      const params = new URLSearchParams()
      params.append('externalCompanyId', this.companyID)
      params.append('vatNumber', location.inv_fiscal_code)
      params.append('page', page)
      params.append('limit', pageSize)

      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/purchases?${params.toString()}`)
        if (!response.ok) throw new Error('Failed to fetch purchases')

        const data = await response.json()
        if (Array.isArray(data.purchases)) {
          clearTimeout(this.loadingTimeout)
          this.loading = false

          this.totalItems = data.total || 0
          this.currentPage = data.currentPage || page
          this.pageSize = data.pageSize || pageSize

          this.tableData = data.purchases.map(p => {
            const totals = p.totals || {}

            return {
              number: p.invoiceNumber || p._id,
              id: p._id,
              anafMessageId: p.anafMessageId,
              supplierName: p.supplier.name || 'N/A',
              taxableValue: this.formatMoney(totals.taxable),
              taxValue: this.formatMoney(totals.tax),
              totalValue: this.formatMoney(totals.total),
              payableValue: this.formatMoney(totals.payable),
              issueDate: p.issueDate || p.createdAt
            }
          })
        } else {
          console.error('Purchases data not in expected format', data)
        }
      } catch (error) {
        clearTimeout(this.loadingTimeout)
        this.loading = false
        console.error('Error fetching purchases:', error)
      }
    },
    async handleDownload (url, errorTitle) {
      const response = await fetch(url, { method: 'GET' })

      const dataText = await response.text()

      var parsed = null
      try {
        parsed = JSON.parse(dataText)
      } catch (e) {
        parsed = null
      }

      if (!response.ok || (parsed && parsed.error)) {
        var msg = 'A apărut o eroare.'

        if (parsed && parsed.anaf_error) {
          try {
            var anafObj = JSON.parse(parsed.anaf_error)
            if (anafObj && anafObj.eroare) {
              msg = anafObj.eroare
            }
          } catch (e) {}
        } else if (parsed && parsed.error) {
          msg = parsed.error
        }

        swal({
          title: errorTitle || 'Eroare',
          text: msg,
          type: 'error',
          timer: 4000,
          showConfirmButton: false
        })

        return null
      }

      return parsed
    },
    async viewPdf (row) {
      try {
        const base =
          process.env.API_BASE_URL_GESTIUNE +
          ':4443/efactura/purchase/pdf/' +
          row.id

        const url =
          row.status === true
            ? base + '?externalCompanyId=' + this.companyID
            : base + '?externalCompanyId=' + this.companyID + '&check=1'

        const result = await this.handleDownload(url, 'Eroare PDF')

        if (!result) return

        // dacă vine JSON cu status true
        if (result.status === true) {
          const downloadUrl =
            base +
            '?externalCompanyId=' +
            this.companyID +
            '&download=1'

          window.open(downloadUrl, '_blank')
        }
      } catch (err) {
        console.error(err)

        swal({
          title: 'Eroare',
          text: 'Eroare neașteptată la încărcarea PDF-ului.',
          type: 'error',
          timer: 4000,
          showConfirmButton: false
        })
      }
    },
    async exportDocument (row) {
      try {
        const base =
          process.env.API_BASE_URL_GESTIUNE +
          ':4443/efactura/inbox/messages/' +
          row.anafMessageId +
          '/download'

        const url =
          row.status === true
            ? base + '?externalCompanyId=' + this.companyID
            : base + '?externalCompanyId=' + this.companyID + '&check=1'

        const result = await this.handleDownload(url, 'Eroare descărcare')

        if (!result) return

        if (result.status === true) {
          const downloadUrl =
            base +
            '?externalCompanyId=' +
            this.companyID +
            '&download=1'

          window.open(downloadUrl, '_blank')
        }
      } catch (err) {
        console.error(err)

        swal({
          title: 'Eroare',
          text: 'Eroare neașteptată la descărcare.',
          type: 'error',
          timer: 4000,
          showConfirmButton: false
        })
      }
    }
  }
}
</script>

<style scoped>
 .action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}
.left-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 160px;
  font-size: 14px;
}
.el-pagination {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Entries/ManagementInvoiceSupplier.vue